export const Email = 0;
export const SMS = 1;
export const EmailAndSMS = 2;
export const Portal = 3;